import { BrandingConfig } from "./branding.config";

// MyHealthNJ does not use high contrast mode. While we normally want to use
// Tailwind Dark mode class names, we need to use custom CSS to override the
// branding styles.
const DARK = "#032238";
const DESKTOP_DARK_OUTER = "#082842";

export const generateBrandingStyles = (branding: BrandingConfig, highContrastMode?: boolean) => {
  return `
      /* Global style overrides */
      html {
        background-color: var(--background-color);

        @media screen and (min-width: 768px) {
          background-color: ${highContrastMode ? DESKTOP_DARK_OUTER : "var(--background-color)"};
        }
      }
      .mobile-background {
        background-color: var(--background-color);
      }
      .high-contrast-visibility {
        display: ${branding.highContrastVisiblity ? "" : "none"};
      }
      .calendar-background {
        background-color: ${branding.mobileCalendarBackground}
      }
      .signup-image {
        background-color: var(--login-background-color);
      }
      .docket-button, .docket-button:disabled {
        background-color: var(--primary-color);
      }

      .docket-button.secondary {
        border: 0.075em solid var(--primary-color);
        background: transparent;
        color: var(--primary-color);
      }
      .docket-navbar, .navbar-dropdown, .docket-footer, .navbar-item, .navbar-link, .navbar-link:hover, .navbar-item.has-dropdown:hover .navbar-link, .navbar-item:hover, .navbar-item:focus {
        background-color: var(--navbar-background);
      }
      .middle-column {
        @media screen and (min-width: 768px) {
        }
      }

      div.login-badge {
        display: none;
      }

      .mobile-card {
        @media screen and (max-width: 767px) {
          box-shadow: ${highContrastMode ? "" : branding.mobileCardShadow};
        }
      }

      .mobile-checkbox {
        border-color: ${branding.mobileTextColor};
        color: ${branding.mobileTextColor};
      }

      .mobile-separator {
        @media screen and (max-width: 767px) {
          border-top-color: ${branding.mobileTextColor};
        }
      }

      .mobile-text-color {
        @media screen and (max-width: 767px) {
          color: ${branding.mobileTextColor} !important;
        }

        input, label, fieldset {
          @media screen and (max-width: 767px) {
            color: ${branding.mobileTextColor} !important;
          }
        }

        input::placeholder {
          @media screen and (max-width: 767px) {
            color: ${branding.mobileTextColor};
          }
        }
      }

      .mobile-text-color::placeholder {
        @media screen and (max-width: 767px) {
          color: ${branding.mobileTextColor};
        }
      }

      .mobile-circle {
        @media (max-width: 767px) {
          border-radius: 50%;
          color: ${branding.mobileTextColor};
          border: 1px solid ${branding.mobileTextColor};
          margin-left: 10px;
          margin-right: 10px;
          width: 42px !important;
          height: 42px !important;
          font-size: 15px;
          font-style: italic;
        }
      }
    `;
};
